import React, { useCallback, useEffect } from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useSnackbar } from '@components/Provider';
import { STORAGE_ACTION, getStorageItem } from '@utils/storage';
import useClient from '@hooks/useClient';
import useMyPage from '@hooks/useMyPage';
import {
  CapaQuotationUser,
  useUpdateQuotationUserMutation,
  CapaErrorCode
} from '@generated/graphql';
import ProfilePresenter from './ProfilePresenter';
import { MyAccountContext } from '../../MyAccountContainer';
import { useHistory } from 'react-router-dom';
import MobileTopNavbarPresenter from '../Common/MobileTopAppBarPresenter';

const ProfileContainer = () => {
  const history = useHistory();
  const context = React.useContext(MyAccountContext);
  const isGhost = getStorageItem(STORAGE_ACTION.IS_GHOST_CLIENT);
  const { enqueueSnackbar } = useSnackbar();
  const { onUpdateProfileField } = useMyPage();
  const [updateQuotationUser] = useUpdateQuotationUserMutation();
  const { clientState, onUpdateClient } = useClient();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));

  useEffect(() => {
    onUpdateProfileField({
      ...context.data,
      field: [{ fieldName: '', content: '' }]
    });
  }, [onUpdateProfileField, context.data]);

  const onUpdate = useCallback(
    (updateData: Partial<CapaQuotationUser>) => {
      if (isGhost && isGhost === 'true') return;
      const input = {
        ...updateData,
        is_individual: undefined,
        id: undefined,
        files: undefined
      };

      if (clientState) {
        updateQuotationUser({
          variables: {
            input: {
              ...input
            }
          }
        })
          .then((result) => {
            if (
              result.data?.updateQuotationUser.result === CapaErrorCode.Success
            ) {
              context.getClientQueryRefetch && context.getClientQueryRefetch();
              result.data.updateQuotationUser.data &&
                onUpdateClient(result.data.updateQuotationUser.data);
              enqueueSnackbar('정보가 성공적으로 수정되었습니다', {
                variant: 'success'
              });
            } else {
              throw Error(
                `${result.data?.updateQuotationUser.result}-${result.data?.updateQuotationUser.errorMessage}`
              );
            }
          })
          .catch(() => {
            enqueueSnackbar(`정보 수정에 실패했습니다.`, { variant: 'error' });
          });
      }
    },
    // eslint-disable-next-line
    [
      clientState.id,
      context.data,
      enqueueSnackbar,
      context.getClientQueryRefetch,
      updateQuotationUser
    ]
  );

  const onChangePath = (path: string) => {
    window.scrollTo({ 'top': 0 });

    return history.push(path);
  };

  return (
    <>
      {matches && <MobileTopNavbarPresenter />}
      <Grid container>
        <ProfilePresenter
          onUpdate={onUpdate}
          onChangePath={onChangePath}
          // openProfileUpdate={() => setOpenProfileUpdate(true)}
        />
      </Grid>
    </>
  );
};

export default ProfileContainer;
